import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { ProsemirrorComponent } from './prosemirror.component';
import { ProsemirrorLinkModalComponent } from './prosemirror-link-modal/prosemirror-link-modal.component';
import { ProsemirrorViewComponent } from './prosemirror-view/prosemirror-view.component';

@NgModule({
  declarations: [
    ProsemirrorComponent,
    ProsemirrorViewComponent,
    ProsemirrorLinkModalComponent,
  ],
  imports: [CommonModule, FormsModule, NgbModule],
  exports: [
    ProsemirrorComponent,
    ProsemirrorViewComponent,
    ProsemirrorLinkModalComponent,
  ],
})
export class ProsemirrorModule {}
